import { useEffect, useState } from 'react';
import './NudgeBanner.css';

// Re-engagement in-app notice (shared-docs/re-engagement-nudges.md Channel 2).
// The store's fetchSubscription() stashes the server's `inAppNudge` in
// localStorage and fires NUDGE_EVENT; this banner renders it once. Dismiss is
// tracked per-nudge-id in localStorage. One banner max; never blocks the UI.

export const NUDGE_EVENT = 'streaks-inapp-nudge';
export const NUDGE_STORAGE_KEY = 'streaks:inAppNudge';

const THIRTY_DAYS_MS = 30 * 24 * 3600 * 1000;

function readStoredNudge() {
  try {
    const raw = localStorage.getItem(NUDGE_STORAGE_KEY);
    if (!raw) return null;
    const nudge = JSON.parse(raw);
    if (!nudge?.id || !nudge?.body) return null;
    if (Number(nudge.createdAt) < Date.now() - THIRTY_DAYS_MS) return null;
    if (localStorage.getItem(`nudgeDismissed:${nudge.id}`)) return null;
    return nudge;
  } catch {
    return null;
  }
}

export default function NudgeBanner() {
  const [nudge, setNudge] = useState(readStoredNudge);

  useEffect(() => {
    const onNudge = () => setNudge(readStoredNudge());
    window.addEventListener(NUDGE_EVENT, onNudge);
    return () => window.removeEventListener(NUDGE_EVENT, onNudge);
  }, []);

  if (!nudge) return null;

  const dismiss = () => {
    try { localStorage.setItem(`nudgeDismissed:${nudge.id}`, '1'); } catch { /* noop */ }
    setNudge(null);
  };

  return (
    <div className="nudge-banner" role="status">
      <div className="nudge-banner__content">
        <p className="nudge-banner__title">{nudge.title || 'Welcome back 👋'}</p>
        <p className="nudge-banner__body">{nudge.body}</p>
      </div>
      <button className="nudge-banner__close" onClick={dismiss} aria-label="Dismiss">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
}
